import React from "react"
import classnames from "classnames"
import styles from "./Typography.less"
import urlHandler from "AtomicUtils/urlHandler"
import gtmHandler from "AtomicUtils/gtmHandler"

class A extends React.PureComponent {
  _handleOnClick = (event) => {
    if (event) event.preventDefault()

    const { onClick = () => { }, external, href, disabled, gtm } = this.props
    onClick(event)

    // Delay for firing GTM before redirection
    // Call GTM if we have an gtm object
    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }

    if (external && href && !disabled) {
      setTimeout(() => {
        new urlHandler(href).newTab()
      }, 200)
    } else if (href && !disabled) {
      setTimeout(() => {
        new urlHandler(href).redirect()
      }, 200)
    }
  }
  render() {
    const {
      children,
      withoutStyle = false,
      styleName="red",
      text=null,
      active=false,
      className='',
      external,
      ...rest
    } = this.props
    return (
      <a
        className={`${classnames({
          [styles.A]: true,
          [styles.withoutStyle]: withoutStyle,
          [styles.redColor]: styleName === "red",
          [styles.whiteColor]: styleName === "white",
          [styles.blackColor]: styleName === "black",
          [styles.greyColor]: styleName === "grey",
          [styles.active]: active,
        })} ${className}`}
        {...rest}
        onClick={this._handleOnClick}
        >
        {!text && children}
        {text && text}
      </a>
    )
  }
}


export default A



// WEBPACK FOOTER //
// ./src/AtomicComponents/Typography/A.jsx